import { NewVersionAvailableError } from './new-version-available-error/NewVersionAvailableError';
import { isNewVersionAvailableError } from './new-version-available-error/NewVersionAvailableError.utils';
import { NoAvailableSpaceError } from './no-available-space-error/NoAvailableSpaceError';
import { isNoAvailableSpaceError } from './no-available-space-error/NoAvailableSpaceError.utils';
import { OfflineError } from './offline-error/OfflineError';
import { isOfflineError } from './offline-error/OfflineError.utils';
import { ErrorViewsProps } from './ErrorViews.types';

export const ErrorViews = ({ error, setError }: ErrorViewsProps) => {
  if (error) {
    if (isOfflineError(error)) {
      return <OfflineError onConfirm={() => setError(undefined)} />;
    } else if (isNoAvailableSpaceError(error)) {
      return <NoAvailableSpaceError />;
    } else if (isNewVersionAvailableError(error)) {
      return <NewVersionAvailableError />;
    }
  }

  return <></>;
};
